<template>
  <div v-if="detail" class="box">
    <CustomNavBar :title="detail.title" />
    <van-row class="list" type="flex" justify="center">
      <van-col span="22">
        <div class="desc" v-html="detail.description" />
      </van-col>
    </van-row>
    <img class="bg-img1" :src="require('@/assets/bg01.png')">
  </div>
</template>

<script>
import { detailInfo } from "@/api/detail";
import CustomNavBar from "@/components/CustomNavBar";
export default {
  name: "DETAIL",
  components: {
    CustomNavBar,
  },
  data() {
    return {
      detail: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$store.commit("set_istab", false);
  },
  methods: {
    getData() {
      const query = this.$route.query;
      detailInfo(query).then((ret) => {
        this.detail = ret;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 800px) {
  .list {
    width: 800px;
    margin: auto;
  }
}

.box {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  position: relative;
  .bg-img1 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 200px;
    height: auto;
  }

  .list {
    background: #fff;
    height: calc(100% - 46px);
    overflow: auto;

    .desc {
      ::v-deep p {
        width: 100%;
        text-indent: 2em;
        white-space: pre-wrap;
        word-break: break-all;
        word-wrap: break-word;
      }

      ::v-deep img {
        border-radius: 8px;
        width: 100% !important;
      }
    }
  }
}
</style>
